export const dashboardCredentialHref = (
  routes: { dashboardCredential?: string },
  credentialId: string,
): string =>
  (routes.dashboardCredential ?? "/dashboard/credentials/:id").replace(
    ":id",
    credentialId,
  );
